import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetcher } from '../../../lib/api-fetcher';

export interface FeeSlab {
  id: string;
  feeType: string;
  calculationType: string;
  config: Record<string, unknown>;
  effectiveFrom: string;
  status: string;
}

export type CreateFeeSlabInput = Omit<FeeSlab, 'id' | 'status'>;

export function useFeeSlabs(params: { page?: number; limit?: number; feeType?: string } = {}) {
  const qs = new URLSearchParams();
  if (params.page) qs.append('page', String(params.page));
  if (params.limit) qs.append('limit', String(params.limit));
  if (params.feeType) qs.append('feeType', params.feeType);

  return useQuery({
    queryKey: ['fee-slabs', params],
    queryFn: () =>
      fetcher
        .get<{ data: FeeSlab[]; meta: { total: number; page: number; limit: number } }>(`/staff/v1/admin/fee-slabs?${qs}`)
        .then((r) => r.data ?? []),
  });
}

export function useCreateFeeSlab() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateFeeSlabInput) =>
      fetcher.post('/staff/v1/admin/fee-slabs', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fee-slabs'] });
    },
  });
}

export function useDeleteFeeSlab() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      fetcher.delete(`/staff/v1/admin/fee-slabs/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fee-slabs'] });
    },
  });
}
